import React from 'react';
export function Footer() {
  return <footer className="bg-card-bg border-t border-[rgba(107,0,182,0.3)] py-[30px] px-5 text-center" data-id="element-47" data-mp="32wd2qgad7ltj">
      <p className="text-[0.8rem] text-white/35 leading-[1.8]" data-id="element-48" data-mp="3ggk6ap6ov1ww">
        © 2025 Dr. Eduardo Ortiz — PIACERE, COLPA E VUOTO · Il Cammino verso la
        Guarigione
        <br data-id="element-49" data-mp="36ooaxlvzlpwd" />
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors duration-200 ease-out" data-id="element-50" data-mp="36q92d2n08sq0">
          Termini e condizioni
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors duration-200 ease-out" data-id="element-51" data-mp="37xyao5wgelp">
          Informativa sulla privacy
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors duration-200 ease-out" data-id="element-52" data-mp="3qf9suv9j5ajh">
          Contatti
        </a>
      </p>
    </footer>;
}